import {IconsEnum, NotificationManager, NotificationModel} from "@systempiloten/react-lib";
import i18n from "i18next";

/** Die Überschriften sind Getter: übersetzt wird beim Anzeigen, beim Laden des Moduls steht die Sprache noch nicht fest. */
export const ErrorNotificationTemplate: NotificationModel = {
    icon: IconsEnum.WARNING,
    get headlineText() {
        return i18n.t("errors.notificationTemplate.error") as string;
    },
    iconColor: "text-sh-status-error",
    background: "bg-sh-status-error",
    strokeColor: "border-sh-status-error",
    duration: 3 * 1000,
}

export const InfoNotificationTemplate: NotificationModel = {
    icon: IconsEnum.INFO,
    get headlineText() {
        return i18n.t("errors.notificationTemplate.info") as string;
    },
    iconColor: "text-sh-status-info",
    background: "bg-sh-status-info",
    strokeColor: "border-sh-status-info",
    duration: 3 * 1000
}

export const SuccessNotificationTemplate: NotificationModel = {
    icon: IconsEnum.SELECTED,
    get headlineText() {
        return i18n.t("errors.notificationTemplate.success") as string;
    },
    iconColor: "text-sh-status-success",
    background: "bg-sh-status-success",
    strokeColor: "border-sh-status-success",
    duration: 3 * 1000
}

export const WarningNotificationTemplate: NotificationModel = {
    icon: IconsEnum.WARNING,
    get headlineText() {
        return i18n.t("errors.notificationTemplate.warning") as string;
    },
    iconColor: "text-sh-brand-yellow",
    background: "bg-sh-brand-yellow",
    strokeColor: "border-sh-brand-yellow",
    duration: 3 * 1000
};

/**
 * Benachrichtigung mit einem der Templates oben anzeigen (SCRUM-229): `notifyError(text)` statt
 * `NotificationManager.getInstance().push({...ErrorNotificationTemplate, text})`. `extra` überschreibt
 * einzelne Felder, etwa `headlineText`. Ohne Text bleibt es beim Text des Templates.
 */
function notify(template: NotificationModel, text?: string, extra?: Partial<NotificationModel>) {
    NotificationManager.getInstance()?.push({...template, ...(text === undefined ? {} : {text}), ...extra});
}

export const notifyError = (text?: string, extra?: Partial<NotificationModel>) => notify(ErrorNotificationTemplate, text, extra);
export const notifyInfo = (text?: string, extra?: Partial<NotificationModel>) => notify(InfoNotificationTemplate, text, extra);
export const notifySuccess = (text?: string, extra?: Partial<NotificationModel>) => notify(SuccessNotificationTemplate, text, extra);
export const notifyWarning = (text?: string, extra?: Partial<NotificationModel>) => notify(WarningNotificationTemplate, text, extra);

/**
 * Der Grund, den der Server zu einem abgelehnten Aufruf nennt (`error` bzw. `message` im Body), sonst die Meldung
 * des Fehlers selbst. Für Meldungen wie „Kopieren fehlgeschlagen: Quelldatei fehlt“.
 */
export function serverErrorReason(error: unknown): string {
    type Body = {error?: unknown; message?: unknown};
    const failure = error as {response?: {body?: Body; data?: Body}; body?: Body; message?: unknown};
    const body = failure?.response?.body ?? failure?.response?.data ?? failure?.body;
    const reason = body?.error ?? body?.message ?? failure?.message;
    return typeof reason === "string" ? reason : "";
}

/** Fehlermeldung „<Aktion> fehlgeschlagen: <Grund>“; ohne Grund nur die Aktion. */
export const notifyFailure = (action: string, error: unknown) => {
    const reason = serverErrorReason(error);
    notifyError(reason ? `${action}: ${reason}` : action);
};
